import { selectUserLocation,queryCarData,queryCarDataCount,queryViolationCount,queryProblemCount,queryCarDataList,queryDriverDataList,getStatisticalData,getCarAgeProportion,getCarCapacityProportion,getCarWorkRate,getCarSpotCheckRate,getCarDistributionState } from "../../api/config/modules/HomePage";

const state = {
    queryCarData: {},
    queryCarDataCount: {},
    queryViolationCount: {},
    queryProblemCount: {},
    queryCarDataList: {},
    queryDriverDataList: {},
    getStatisticalData: {},
    getCarAgeProportion: {},
    getCarCapacityProportion: {},
    getCarWorkRate: {},
    getCarSpotCheckRate: {},
    getCarDistributionState: {},
    selectUserLocation: {}
};

const mutations = {
  SET_QUERYCARDATA: (state, queryCarData) => {
    state.queryCarData = queryCarData;
  },
  SET_QUERYCARDATACOUNT: (state, queryCarDataCount) => {
    state.queryCarDataCount = queryCarDataCount;
  },
  SET_QUERYVIOLATIONCOUNT: (state, queryViolationCount) => {
    state.queryViolationCount = queryViolationCount;
  },
  SET_QUERYPROBLEMCOUNT: (state, queryProblemCount) => {
    state.queryProblemCount = queryProblemCount;
  },
  SET_QUERYCARDATALIST: (state, queryCarDataList) => {
    state.queryCarDataList = queryCarDataList;
  },
  SET_QUERYDRIVERDATALIST: (state, queryDriverDataList) => {
    state.queryDriverDataList = queryDriverDataList;
  },
  SET_GETSTATISTICALDATA: (state, getStatisticalData) => {
    state.getStatisticalData = getStatisticalData;
  },
  SET_GETCARAGEPROPORTION: (state, getCarAgeProportion) => {
    state.getCarAgeProportion = getCarAgeProportion;
  },
  SET_GETCARCAPACITYPROPORTION: (state, getCarCapacityProportion) => {
    state.getCarCapacityProportion = getCarCapacityProportion;
  },
  SET_GETCARWORKRATE: (state, getCarWorkRate) => {
    state.getCarWorkRate = getCarWorkRate;
  },
  SET_GETCARSPOTCHECKRATE: (state, getCarSpotCheckRate) => {
    state.getCarSpotCheckRate = getCarSpotCheckRate;
  },
  SET_GETCARDISTRIBUTIONSTATE: (state, getCarDistributionState) => {
    state.getCarDistributionState = getCarDistributionState;
  },
  SET_SELECTUSERLOCATION: (state, selectUserLocation) => {
    state.selectUserLocation = selectUserLocation;
  },
};

const actions = {
  GET_QUERYCARDATA: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        queryCarData(data)
        .then((res) => {
          commit("SET_QUERYCARDATA", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYCARDATACOUNT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      queryCarDataCount(data)
        .then((res) => {
          commit("SET_QUERYCARDATACOUNT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYVIOLATIONCOUNT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      queryViolationCount(data)
        .then((res) => {
          commit("SET_QUERYVIOLATIONCOUNT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYPROBLEMCOUNT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      queryProblemCount(data)
        .then((res) => {
          commit("SET_QUERYPROBLEMCOUNT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYCARDATALIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      queryCarDataList(data)
        .then((res) => {
          commit("SET_QUERYCARDATALIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYDRIVERDATALIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      queryDriverDataList(data)
        .then((res) => {
          commit("SET_QUERYDRIVERDATALIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETSTATISTICALDATA: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getStatisticalData(data)
        .then((res) => {
          commit("SET_GETSTATISTICALDATA", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETCARAGEPROPORTION: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getCarAgeProportion(data)
        .then((res) => {
          commit("SET_GETCARAGEPROPORTION", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETCARCAPACITYPROPORTION: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getCarCapacityProportion(data)
        .then((res) => {
          commit("SET_GETCARCAPACITYPROPORTION", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETCARWORKRATE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getCarWorkRate(data)
        .then((res) => {
          commit("SET_GETCARWORKRATE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETCARSPOTCHECKRATE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getCarSpotCheckRate(data)
        .then((res) => {
          commit("SET_GETCARSPOTCHECKRATE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETCARDISTRIBUTIONSTATE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getCarDistributionState(data)
        .then((res) => {
          commit("SET_GETCARDISTRIBUTIONSTATE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTUSERLOCATION: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectUserLocation(data)
        .then((res) => {
          commit("SET_SELECTUSERLOCATION", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
